import * as z from 'zod'
import { Location, Taxipark } from '~/shared/api'
import { dateSchema, uuidOptionSchema } from '~/shared/lib/schemas'
import { FuelTypeEnum, TransmissionEnum } from '../config/enums'
import { ApiModel, ToOneRelation } from './core'

const attributesSchema = z.object({
  manufactureYear: z.string(),
  color: z.string(),
  fuelType: z.nativeEnum(FuelTypeEnum),
  brand: z.string(),
  model: z.string(),
  plateNumber: z.string(),
  pricePerDay: z.number(),
  transmission: z.nativeEnum(TransmissionEnum),
  vehicleCategory: z.string(),
  photos: z.array(z.string()),
  isLeasingFullyPaid: z.boolean().optional(),
  mileage: z.number(),
  cancellationFeeRub: z.number().nullable(),
  cancellationFeePercentage: z.number(),
  isSupportOpenCloseDoors: z.boolean().optional(),
})

const relationsSchema = z.object({
  locationId: uuidOptionSchema,
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributesSchema)
  .merge(relationsSchema)

export type CarAttributes = z.infer<typeof attributesSchema>

export class Car extends ApiModel<typeof schema, CarAttributes> {
  static jsonApiType = 'cars'

  static schema = schema

  getModel(): string {
    return this.getAttribute('model')
  }
  getBrand(): string {
    return this.getAttribute('brand')
  }
  getPlateNumber(): string {
    return this.getAttribute('plateNumber')
  }
  getPricePerDay(): number {
    return this.getAttribute('pricePerDay')
  }
  getPhotos(): string[] {
    return this.getAttribute('photos')
  }
  getIsLeasingFullyPaid(): boolean {
    return this.getAttribute('isLeasingFullyPaid')
  }
  getCancellationFeeRub(): number | null {
    return this.getAttribute('cancellationFeeRub')
  }
  getIsSupportOpenCloseDoors(): boolean {
    return this.getAttribute('isSupportOpenCloseDoors')
  }

  location(): ToOneRelation<Location, this> {
    return this.hasOne(Location)
  }
  getLocation(): Location {
    return this.getRelation('location')
  }

  taxipark(): ToOneRelation<Taxipark, this> {
    return this.hasOne(Taxipark)
  }
  getTaxipark(): Taxipark {
    return this.getRelation('taxipark')
  }
}
